/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CustomerSpecificPricingDetail,
  CustomerSpecificPricingResponse,
  IdentityResponse,
  InvoiceAuditsResponse,
  LinkExchangeRequest,
  OperationalIssueResponseRequest,
  OperationalIssueResponseResult,
  OperationalIssuesResponse,
  OpportunitiesResponse,
  OpportunityDatafile,
  OpportunityDetail,
  OpportunityInterestResponse,
  OpportunityPackage,
  PageViewRequest,
  PerformanceExport,
  PerformanceLaneDetail,
  PerformanceResponse,
  SessionResponse,
  ShipmentDetail,
  ShipmentDocumentContent,
  ShipmentDocumentsResponse,
  ShipmentExport,
  ShipmentInvoiceDetail,
  ShipmentListResponse,
  ShipmentStatusFilter,
  ShipmentTrackingResponse,
} from "../models/index";
import {
  CustomerSpecificPricingDetailFromJSON,
  CustomerSpecificPricingDetailToJSON,
  CustomerSpecificPricingResponseFromJSON,
  CustomerSpecificPricingResponseToJSON,
  IdentityResponseFromJSON,
  IdentityResponseToJSON,
  InvoiceAuditsResponseFromJSON,
  InvoiceAuditsResponseToJSON,
  LinkExchangeRequestFromJSON,
  LinkExchangeRequestToJSON,
  OperationalIssueResponseRequestFromJSON,
  OperationalIssueResponseRequestToJSON,
  OperationalIssueResponseResultFromJSON,
  OperationalIssueResponseResultToJSON,
  OperationalIssuesResponseFromJSON,
  OperationalIssuesResponseToJSON,
  OpportunitiesResponseFromJSON,
  OpportunitiesResponseToJSON,
  OpportunityDatafileFromJSON,
  OpportunityDatafileToJSON,
  OpportunityDetailFromJSON,
  OpportunityDetailToJSON,
  OpportunityInterestResponseFromJSON,
  OpportunityInterestResponseToJSON,
  OpportunityPackageFromJSON,
  OpportunityPackageToJSON,
  PageViewRequestFromJSON,
  PageViewRequestToJSON,
  PerformanceExportFromJSON,
  PerformanceExportToJSON,
  PerformanceLaneDetailFromJSON,
  PerformanceLaneDetailToJSON,
  PerformanceResponseFromJSON,
  PerformanceResponseToJSON,
  SessionResponseFromJSON,
  SessionResponseToJSON,
  ShipmentDetailFromJSON,
  ShipmentDetailToJSON,
  ShipmentDocumentContentFromJSON,
  ShipmentDocumentContentToJSON,
  ShipmentDocumentsResponseFromJSON,
  ShipmentDocumentsResponseToJSON,
  ShipmentExportFromJSON,
  ShipmentExportToJSON,
  ShipmentInvoiceDetailFromJSON,
  ShipmentInvoiceDetailToJSON,
  ShipmentListResponseFromJSON,
  ShipmentListResponseToJSON,
  ShipmentStatusFilterFromJSON,
  ShipmentStatusFilterToJSON,
  ShipmentTrackingResponseFromJSON,
  ShipmentTrackingResponseToJSON,
} from "../models/index";

export interface DownloadCarrierOpportunityDatafileRequest {
  companyId: string;
}

export interface DownloadCarrierShipmentDocumentRequest {
  shipmentId: string;
  documentId: string;
}

export interface ExchangeCarrierLinkRequest {
  linkExchangeRequest: LinkExchangeRequest;
}

export interface ExportCarrierPerformanceRequest {
  fromDate: string;
  toDate: string;
}

export interface ExportCarrierShipmentsRequest {
  search?: string;
  status?: ShipmentStatusFilter;
  fromDate?: string;
  toDate?: string;
  pickup?: string;
  delivery?: string;
  service?: string;
}

export interface GetCarrierCustomerSpecificPricingAgreementRequest {
  agreementId: string;
}

export interface GetCarrierOpportunityRequest {
  companyId: string;
}

export interface GetCarrierOpportunityPackageRequest {
  companyId: string;
}

export interface GetCarrierPerformanceRequest {
  fromDate: string;
  toDate: string;
}

export interface GetCarrierPerformanceLaneRequest {
  fromDate: string;
  toDate: string;
  pickup: string;
  delivery: string;
}

export interface GetCarrierShipmentRequest {
  shipmentId: string;
}

export interface GetCarrierShipmentDocumentsRequest {
  shipmentId: string;
}

export interface GetCarrierShipmentInvoiceRequest {
  shipmentId: string;
}

export interface GetCarrierShipmentTrackingRequest {
  shipmentId: string;
}

export interface GetCarrierShipmentsRequest {
  search?: string;
  status?: ShipmentStatusFilter;
  fromDate?: string;
  toDate?: string;
  pickup?: string;
  delivery?: string;
  service?: string;
  page?: number;
  pageSize?: number;
}

export interface MarkCarrierOpportunityInterestedRequest {
  companyId: string;
}

export interface RecordCarrierPageViewRequest {
  pageViewRequest: PageViewRequest;
}

export interface RespondToCarrierOperationalIssueRequest {
  operationalIssueResponseRequest: OperationalIssueResponseRequest;
}

/**
 *
 */
export class CarriersApi extends runtime.BaseAPI {
  /**
   * The datafile a FreightSimple rep built for this customer — the shipment-level file carriers actually price from, offered as a download rather than an email attachment.  Unlocked by registering interest, and 404 when no datafile has been prepared yet.
   * Download the shipment-level datafile for one customer
   */
  async downloadCarrierOpportunityDatafileRaw(
    requestParameters: DownloadCarrierOpportunityDatafileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OpportunityDatafile>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling downloadCarrierOpportunityDatafile().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/opportunities/{companyId}/datafile`.replace(
          `{${"companyId"}}`,
          encodeURIComponent(String(requestParameters["companyId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OpportunityDatafileFromJSON(jsonValue),
    );
  }

  /**
   * The datafile a FreightSimple rep built for this customer — the shipment-level file carriers actually price from, offered as a download rather than an email attachment.  Unlocked by registering interest, and 404 when no datafile has been prepared yet.
   * Download the shipment-level datafile for one customer
   */
  async downloadCarrierOpportunityDatafile(
    requestParameters: DownloadCarrierOpportunityDatafileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OpportunityDatafile> {
    const response = await this.downloadCarrierOpportunityDatafileRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The document itself, base64-encoded, streamed through the API rather than handed out as a signed storage URL — so the carrier scoping is checked on every fetch and there is no link that outlives it.  A document on another carrier\'s shipment, or of a kind not on the allowlist, is a 404 rather than a 403: the portal never confirms that something it won\'t serve exists.
   * Download one document
   */
  async downloadCarrierShipmentDocumentRaw(
    requestParameters: DownloadCarrierShipmentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentDocumentContent>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling downloadCarrierShipmentDocument().',
      );
    }

    if (requestParameters["documentId"] == null) {
      throw new runtime.RequiredError(
        "documentId",
        'Required parameter "documentId" was null or undefined when calling downloadCarrierShipmentDocument().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipments/{shipmentId}/documents/{documentId}`
          .replace(
            `{${"shipmentId"}}`,
            encodeURIComponent(String(requestParameters["shipmentId"])),
          )
          .replace(
            `{${"documentId"}}`,
            encodeURIComponent(String(requestParameters["documentId"])),
          ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentDocumentContentFromJSON(jsonValue),
    );
  }

  /**
   * The document itself, base64-encoded, streamed through the API rather than handed out as a signed storage URL — so the carrier scoping is checked on every fetch and there is no link that outlives it.  A document on another carrier\'s shipment, or of a kind not on the allowlist, is a 404 rather than a 403: the portal never confirms that something it won\'t serve exists.
   * Download one document
   */
  async downloadCarrierShipmentDocument(
    requestParameters: DownloadCarrierShipmentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentDocumentContent> {
    const response = await this.downloadCarrierShipmentDocumentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Exchange a signed login link for a session token
   */
  async exchangeCarrierLinkRaw(
    requestParameters: ExchangeCarrierLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SessionResponse>> {
    if (requestParameters["linkExchangeRequest"] == null) {
      throw new runtime.RequiredError(
        "linkExchangeRequest",
        'Required parameter "linkExchangeRequest" was null or undefined when calling exchangeCarrierLink().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/carriers-api/v1/auth/exchange`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LinkExchangeRequestToJSON(
          requestParameters["linkExchangeRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SessionResponseFromJSON(jsonValue),
    );
  }

  /**
   * Exchange a signed login link for a session token
   */
  async exchangeCarrierLink(
    requestParameters: ExchangeCarrierLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SessionResponse> {
    const response = await this.exchangeCarrierLinkRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * One row per shipment booked with this carrier in the range, carrying the columns the page\'s metrics are computed from: the lane, the freight, the window they quoted, when it actually delivered, and what we paid them.  Exists so a carrier can check our arithmetic against their own system rather than take the summary on trust. That is the whole point, so the columns are the metric inputs and nothing else — no other carrier, no customer, and nothing about what the customer paid us.
   * Download the shipments behind the performance figures
   */
  async exportCarrierPerformanceRaw(
    requestParameters: ExportCarrierPerformanceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceExport>> {
    if (requestParameters["fromDate"] == null) {
      throw new runtime.RequiredError(
        "fromDate",
        'Required parameter "fromDate" was null or undefined when calling exportCarrierPerformance().',
      );
    }

    if (requestParameters["toDate"] == null) {
      throw new runtime.RequiredError(
        "toDate",
        'Required parameter "toDate" was null or undefined when calling exportCarrierPerformance().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["fromDate"] != null) {
      queryParameters["fromDate"] = requestParameters["fromDate"];
    }

    if (requestParameters["toDate"] != null) {
      queryParameters["toDate"] = requestParameters["toDate"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/performance/export`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PerformanceExportFromJSON(jsonValue),
    );
  }

  /**
   * One row per shipment booked with this carrier in the range, carrying the columns the page\'s metrics are computed from: the lane, the freight, the window they quoted, when it actually delivered, and what we paid them.  Exists so a carrier can check our arithmetic against their own system rather than take the summary on trust. That is the whole point, so the columns are the metric inputs and nothing else — no other carrier, no customer, and nothing about what the customer paid us.
   * Download the shipments behind the performance figures
   */
  async exportCarrierPerformance(
    requestParameters: ExportCarrierPerformanceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceExport> {
    const response = await this.exportCarrierPerformanceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The same shipments the list is showing, as a file. Carriers reconcile against their own systems constantly, and doing that a page at a time is not reconciling.  Honours every filter, and ignores pagination: an export of one page would be a trap.
   * Download the shipment list as a CSV
   */
  async exportCarrierShipmentsRaw(
    requestParameters: ExportCarrierShipmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentExport>> {
    const queryParameters: any = {};

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["fromDate"] != null) {
      queryParameters["fromDate"] = requestParameters["fromDate"];
    }

    if (requestParameters["toDate"] != null) {
      queryParameters["toDate"] = requestParameters["toDate"];
    }

    if (requestParameters["pickup"] != null) {
      queryParameters["pickup"] = requestParameters["pickup"];
    }

    if (requestParameters["delivery"] != null) {
      queryParameters["delivery"] = requestParameters["delivery"];
    }

    if (requestParameters["service"] != null) {
      queryParameters["service"] = requestParameters["service"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipments/export`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentExportFromJSON(jsonValue),
    );
  }

  /**
   * The same shipments the list is showing, as a file. Carriers reconcile against their own systems constantly, and doing that a page at a time is not reconciling.  Honours every filter, and ignores pagination: an export of one page would be a trap.
   * Download the shipment list as a CSV
   */
  async exportCarrierShipments(
    requestParameters: ExportCarrierShipmentsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentExport> {
    const response = await this.exportCarrierShipmentsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The customer-specific pricing agreements between FreightSimple and this carrier. Returns active agreements, ones in progress (awaiting the carrier\'s pricing, being set up), and recently ended ones (declined, cancelled, marked as the carrier\'s existing customer). Internal-only drafts are never returned. Each agreement carries its state, the next step, and how the customer is engaging with the pricing (quotes / bookings).
   * Customers FreightSimple holds customer-specific pricing for with this carrier
   */
  async getCarrierCustomerSpecificPricingRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomerSpecificPricingResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/customer-specific-pricing`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomerSpecificPricingResponseFromJSON(jsonValue),
    );
  }

  /**
   * The customer-specific pricing agreements between FreightSimple and this carrier. Returns active agreements, ones in progress (awaiting the carrier\'s pricing, being set up), and recently ended ones (declined, cancelled, marked as the carrier\'s existing customer). Internal-only drafts are never returned. Each agreement carries its state, the next step, and how the customer is engaging with the pricing (quotes / bookings).
   * Customers FreightSimple holds customer-specific pricing for with this carrier
   */
  async getCarrierCustomerSpecificPricing(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomerSpecificPricingResponse> {
    const response =
      await this.getCarrierCustomerSpecificPricingRaw(initOverrides);
    return await response.value();
  }

  /**
   * Full detail for a single agreement: the agreement summary, engagement stats (quotes, bookings, win rate, paid), a month-by-month series, and a lifecycle timeline. Scoped to the signed-in carrier — an agreement that belongs to another carrier is treated as not found, so a guessed id leaks nothing.
   * Detail for one customer-specific pricing agreement
   */
  async getCarrierCustomerSpecificPricingAgreementRaw(
    requestParameters: GetCarrierCustomerSpecificPricingAgreementRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomerSpecificPricingDetail>> {
    if (requestParameters["agreementId"] == null) {
      throw new runtime.RequiredError(
        "agreementId",
        'Required parameter "agreementId" was null or undefined when calling getCarrierCustomerSpecificPricingAgreement().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["agreementId"] != null) {
      queryParameters["agreementId"] = requestParameters["agreementId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/customer-specific-pricing/agreement`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomerSpecificPricingDetailFromJSON(jsonValue),
    );
  }

  /**
   * Full detail for a single agreement: the agreement summary, engagement stats (quotes, bookings, win rate, paid), a month-by-month series, and a lifecycle timeline. Scoped to the signed-in carrier — an agreement that belongs to another carrier is treated as not found, so a guessed id leaks nothing.
   * Detail for one customer-specific pricing agreement
   */
  async getCarrierCustomerSpecificPricingAgreement(
    requestParameters: GetCarrierCustomerSpecificPricingAgreementRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomerSpecificPricingDetail> {
    const response = await this.getCarrierCustomerSpecificPricingAgreementRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The signed-in carrier\'s identity
   */
  async getCarrierIdentityRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IdentityResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/me`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IdentityResponseFromJSON(jsonValue),
    );
  }

  /**
   * The signed-in carrier\'s identity
   */
  async getCarrierIdentity(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IdentityResponse> {
    const response = await this.getCarrierIdentityRaw(initOverrides);
    return await response.value();
  }

  /**
   * Shipments booked with the signed-in carrier where FreightSimple has an open invoice audit — the carrier\'s invoice didn\'t match the quote and we\'re working out the difference. Each entry carries carrier-friendly labels for the unresolved problems and whose turn the conversation is on. Internal audit detail (fault, confidence, evidence, notes) is never returned.
   * The carrier\'s shipments whose invoice is currently in audit
   */
  async getCarrierInvoiceAuditsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InvoiceAuditsResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/invoice-audits`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvoiceAuditsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Shipments booked with the signed-in carrier where FreightSimple has an open invoice audit — the carrier\'s invoice didn\'t match the quote and we\'re working out the difference. Each entry carries carrier-friendly labels for the unresolved problems and whose turn the conversation is on. Internal audit detail (fault, confidence, evidence, notes) is never returned.
   * The carrier\'s shipments whose invoice is currently in audit
   */
  async getCarrierInvoiceAudits(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InvoiceAuditsResponse> {
    const response = await this.getCarrierInvoiceAuditsRaw(initOverrides);
    return await response.value();
  }

  /**
   * The open operational tasks that need the carrier\'s attention, scoped to shipments booked with the signed-in carrier. Only carrier-actionable task types are surfaced; internal tasks (e.g. broker changes, customer billing) are never returned. Shipments pending customs clearance are included as a synthetic issue type.
   * Open operational issues on the carrier\'s shipments
   */
  async getCarrierOperationalIssuesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OperationalIssuesResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/operational-issues`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OperationalIssuesResponseFromJSON(jsonValue),
    );
  }

  /**
   * The open operational tasks that need the carrier\'s attention, scoped to shipments booked with the signed-in carrier. Only carrier-actionable task types are surfaced; internal tasks (e.g. broker changes, customer billing) are never returned. Shipments pending customs clearance are included as a synthetic issue type.
   * Open operational issues on the carrier\'s shipments
   */
  async getCarrierOperationalIssues(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OperationalIssuesResponse> {
    const response = await this.getCarrierOperationalIssuesRaw(initOverrides);
    return await response.value();
  }

  /**
   * The customers FreightSimple is currently seeking customer-specific pricing for. Every carrier sees the same list — there is no per-carrier gatekeeping — but each row is annotated with this carrier\'s own position: their agreement if one exists, whether they already quote the customer and how they\'re doing, and what share of the customer\'s freight falls inside their service area.  A customer appears only once a FreightSimple rep has written the opportunity narrative, which is the deliberate act of publishing it.
   * Customers looking for customer-specific pricing, open to every carrier
   */
  async getCarrierOpportunitiesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OpportunitiesResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/opportunities`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OpportunitiesResponseFromJSON(jsonValue),
    );
  }

  /**
   * The customers FreightSimple is currently seeking customer-specific pricing for. Every carrier sees the same list — there is no per-carrier gatekeeping — but each row is annotated with this carrier\'s own position: their agreement if one exists, whether they already quote the customer and how they\'re doing, and what share of the customer\'s freight falls inside their service area.  A customer appears only once a FreightSimple rep has written the opportunity narrative, which is the deliberate act of publishing it.
   * Customers looking for customer-specific pricing, open to every carrier
   */
  async getCarrierOpportunities(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OpportunitiesResponse> {
    const response = await this.getCarrierOpportunitiesRaw(initOverrides);
    return await response.value();
  }

  /**
   * What a carrier needs to decide whether this customer is worth pricing: volume and spend with the data window stamped on it, volume by pickup location, the lane summary, the freight profile, this carrier\'s coverage of the freight, and where they already stand. Available to every carrier for every published opportunity.  A company that is not a published opportunity is treated as not found, so this endpoint reveals nothing about companies we aren\'t advertising.
   * The high-level opportunity package for one customer
   */
  async getCarrierOpportunityRaw(
    requestParameters: GetCarrierOpportunityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OpportunityDetail>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCarrierOpportunity().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/opportunities/{companyId}`.replace(
          `{${"companyId"}}`,
          encodeURIComponent(String(requestParameters["companyId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OpportunityDetailFromJSON(jsonValue),
    );
  }

  /**
   * What a carrier needs to decide whether this customer is worth pricing: volume and spend with the data window stamped on it, volume by pickup location, the lane summary, the freight profile, this carrier\'s coverage of the freight, and where they already stand. Available to every carrier for every published opportunity.  A company that is not a published opportunity is treated as not found, so this endpoint reveals nothing about companies we aren\'t advertising.
   * The high-level opportunity package for one customer
   */
  async getCarrierOpportunity(
    requestParameters: GetCarrierOpportunityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OpportunityDetail> {
    const response = await this.getCarrierOpportunityRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Everything the emailed CSP report carries, as a page: the complete lane table, weight and density distributions, the accessorial profile, and month-by-month volume.  Unlocked by registering interest. A carrier who has not done so gets a 404, the same answer a company we aren\'t advertising gives, so this endpoint never confirms anything the opportunity list didn\'t already say.  The package characterises the freight. It carries no target rate and computes none — that judgement stays with the person who builds the datafile.
   * The full opportunity package for one customer
   */
  async getCarrierOpportunityPackageRaw(
    requestParameters: GetCarrierOpportunityPackageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OpportunityPackage>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCarrierOpportunityPackage().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/opportunities/{companyId}/package`.replace(
          `{${"companyId"}}`,
          encodeURIComponent(String(requestParameters["companyId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OpportunityPackageFromJSON(jsonValue),
    );
  }

  /**
   * Everything the emailed CSP report carries, as a page: the complete lane table, weight and density distributions, the accessorial profile, and month-by-month volume.  Unlocked by registering interest. A carrier who has not done so gets a 404, the same answer a company we aren\'t advertising gives, so this endpoint never confirms anything the opportunity list didn\'t already say.  The package characterises the freight. It carries no target rate and computes none — that judgement stays with the person who builds the datafile.
   * The full opportunity package for one customer
   */
  async getCarrierOpportunityPackage(
    requestParameters: GetCarrierOpportunityPackageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OpportunityPackage> {
    const response = await this.getCarrierOpportunityPackageRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Every figure is scoped to an explicit date range rather than a preset. Carriers argue about specific months — a quarter that went badly, the week a terminal flooded — and a fixed \"last 90 days\" cannot answer that.  Both bounds are inclusive calendar dates in Vancouver time, which is the timezone every other date in the portal is stated in.
   * The signed-in carrier\'s service performance with FreightSimple
   */
  async getCarrierPerformanceRaw(
    requestParameters: GetCarrierPerformanceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceResponse>> {
    if (requestParameters["fromDate"] == null) {
      throw new runtime.RequiredError(
        "fromDate",
        'Required parameter "fromDate" was null or undefined when calling getCarrierPerformance().',
      );
    }

    if (requestParameters["toDate"] == null) {
      throw new runtime.RequiredError(
        "toDate",
        'Required parameter "toDate" was null or undefined when calling getCarrierPerformance().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["fromDate"] != null) {
      queryParameters["fromDate"] = requestParameters["fromDate"];
    }

    if (requestParameters["toDate"] != null) {
      queryParameters["toDate"] = requestParameters["toDate"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/performance`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PerformanceResponseFromJSON(jsonValue),
    );
  }

  /**
   * Every figure is scoped to an explicit date range rather than a preset. Carriers argue about specific months — a quarter that went badly, the week a terminal flooded — and a fixed \"last 90 days\" cannot answer that.  Both bounds are inclusive calendar dates in Vancouver time, which is the timezone every other date in the portal is stated in.
   * The signed-in carrier\'s service performance with FreightSimple
   */
  async getCarrierPerformance(
    requestParameters: GetCarrierPerformanceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceResponse> {
    const response = await this.getCarrierPerformanceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Everything behind a single row of the lane table: the lane\'s own figures, its win rate month by month, and the individual shipments this carrier quoted on it with where each one ranked.  This is where a carrier finds out *which* freight they are losing rather than only that they are losing some. Each shipment carries their own rank; none carries a price or a premium, and no other carrier is named.
   * One lane, shipment by shipment
   */
  async getCarrierPerformanceLaneRaw(
    requestParameters: GetCarrierPerformanceLaneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceLaneDetail>> {
    if (requestParameters["fromDate"] == null) {
      throw new runtime.RequiredError(
        "fromDate",
        'Required parameter "fromDate" was null or undefined when calling getCarrierPerformanceLane().',
      );
    }

    if (requestParameters["toDate"] == null) {
      throw new runtime.RequiredError(
        "toDate",
        'Required parameter "toDate" was null or undefined when calling getCarrierPerformanceLane().',
      );
    }

    if (requestParameters["pickup"] == null) {
      throw new runtime.RequiredError(
        "pickup",
        'Required parameter "pickup" was null or undefined when calling getCarrierPerformanceLane().',
      );
    }

    if (requestParameters["delivery"] == null) {
      throw new runtime.RequiredError(
        "delivery",
        'Required parameter "delivery" was null or undefined when calling getCarrierPerformanceLane().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["fromDate"] != null) {
      queryParameters["fromDate"] = requestParameters["fromDate"];
    }

    if (requestParameters["toDate"] != null) {
      queryParameters["toDate"] = requestParameters["toDate"];
    }

    if (requestParameters["pickup"] != null) {
      queryParameters["pickup"] = requestParameters["pickup"];
    }

    if (requestParameters["delivery"] != null) {
      queryParameters["delivery"] = requestParameters["delivery"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/performance/lane`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PerformanceLaneDetailFromJSON(jsonValue),
    );
  }

  /**
   * Everything behind a single row of the lane table: the lane\'s own figures, its win rate month by month, and the individual shipments this carrier quoted on it with where each one ranked.  This is where a carrier finds out *which* freight they are losing rather than only that they are losing some. Each shipment carries their own rank; none carries a price or a premium, and no other carrier is named.
   * One lane, shipment by shipment
   */
  async getCarrierPerformanceLane(
    requestParameters: GetCarrierPerformanceLaneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceLaneDetail> {
    const response = await this.getCarrierPerformanceLaneRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Scoped to the signed-in carrier: a shipment booked with another carrier (or not booked with this one) is treated as not found, so a guessed id leaks nothing.
   * Key details for one of the carrier\'s booked shipments
   */
  async getCarrierShipmentRaw(
    requestParameters: GetCarrierShipmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentDetail>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getCarrierShipment().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipment`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentDetailFromJSON(jsonValue),
    );
  }

  /**
   * Scoped to the signed-in carrier: a shipment booked with another carrier (or not booked with this one) is treated as not found, so a guessed id leaks nothing.
   * Key details for one of the carrier\'s booked shipments
   */
  async getCarrierShipment(
    requestParameters: GetCarrierShipmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentDetail> {
    const response = await this.getCarrierShipmentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The paperwork for one shipment, limited to four kinds: the bill of lading we issued, the copy the driver scanned, the proof of delivery, and any customs documents.  Two of those we already email the carrier, and two came from them in the first place — so this is a place to find them again, not new exposure. Everything else a shipment accumulates (claim photos, invoice audit reports, email attachments, internal reports) is unreachable here.
   * Documents on the shipment the carrier may see
   */
  async getCarrierShipmentDocumentsRaw(
    requestParameters: GetCarrierShipmentDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentDocumentsResponse>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getCarrierShipmentDocuments().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipments/{shipmentId}/documents`.replace(
          `{${"shipmentId"}}`,
          encodeURIComponent(String(requestParameters["shipmentId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentDocumentsResponseFromJSON(jsonValue),
    );
  }

  /**
   * The paperwork for one shipment, limited to four kinds: the bill of lading we issued, the copy the driver scanned, the proof of delivery, and any customs documents.  Two of those we already email the carrier, and two came from them in the first place — so this is a place to find them again, not new exposure. Everything else a shipment accumulates (claim photos, invoice audit reports, email attachments, internal reports) is unreachable here.
   * Documents on the shipment the carrier may see
   */
  async getCarrierShipmentDocuments(
    requestParameters: GetCarrierShipmentDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentDocumentsResponse> {
    const response = await this.getCarrierShipmentDocumentsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Everything behind the money on a shipment: what we agreed to pay, what the carrier invoiced, and — when the shipment is under audit — the problems we identified and the challenges we already sent about them.  Read-only by design. A carrier settles an audit by replying to the email, not through the portal; this exists so that reply is written knowing what we\'re basing the challenge on.  The challenge bodies are the emails the carrier already received, shown back verbatim. The portal never states our position in different words than the ones we sent.  Deliberately absent: our internal notes on a problem, the internal evidence behind it, our own carrier price derivation, whether we absorbed a cost, and anything about any other carrier.
   * The invoice and audit evidence for one shipment
   */
  async getCarrierShipmentInvoiceRaw(
    requestParameters: GetCarrierShipmentInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentInvoiceDetail>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getCarrierShipmentInvoice().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipments/{shipmentId}/invoice`.replace(
          `{${"shipmentId"}}`,
          encodeURIComponent(String(requestParameters["shipmentId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentInvoiceDetailFromJSON(jsonValue),
    );
  }

  /**
   * Everything behind the money on a shipment: what we agreed to pay, what the carrier invoiced, and — when the shipment is under audit — the problems we identified and the challenges we already sent about them.  Read-only by design. A carrier settles an audit by replying to the email, not through the portal; this exists so that reply is written knowing what we\'re basing the challenge on.  The challenge bodies are the emails the carrier already received, shown back verbatim. The portal never states our position in different words than the ones we sent.  Deliberately absent: our internal notes on a problem, the internal evidence behind it, our own carrier price derivation, whether we absorbed a cost, and anything about any other carrier.
   * The invoice and audit evidence for one shipment
   */
  async getCarrierShipmentInvoice(
    requestParameters: GetCarrierShipmentInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentInvoiceDetail> {
    const response = await this.getCarrierShipmentInvoiceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Every tracking line on the shipment, oldest first — including the ones this carrier posted itself when answering an operational issue, so what they told us and what the customer sees are visibly the same thing.  `manual_created_by` is not returned: it holds the email of whoever posted a line, and on our side that is a FreightSimple person.
   * The shipment\'s tracking timeline
   */
  async getCarrierShipmentTrackingRaw(
    requestParameters: GetCarrierShipmentTrackingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentTrackingResponse>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getCarrierShipmentTracking().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipments/{shipmentId}/tracking`.replace(
          `{${"shipmentId"}}`,
          encodeURIComponent(String(requestParameters["shipmentId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentTrackingResponseFromJSON(jsonValue),
    );
  }

  /**
   * Every tracking line on the shipment, oldest first — including the ones this carrier posted itself when answering an operational issue, so what they told us and what the customer sees are visibly the same thing.  `manual_created_by` is not returned: it holds the email of whoever posted a line, and on our side that is a FreightSimple person.
   * The shipment\'s tracking timeline
   */
  async getCarrierShipmentTracking(
    requestParameters: GetCarrierShipmentTrackingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentTrackingResponse> {
    const response = await this.getCarrierShipmentTrackingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Searchable, filterable and paginated over the carrier\'s whole history.  Filtering happens here rather than in the browser because the list is paginated: filtering a single page would quietly answer a different question from the one asked.
   * The carrier\'s booked shipments
   */
  async getCarrierShipmentsRaw(
    requestParameters: GetCarrierShipmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentListResponse>> {
    const queryParameters: any = {};

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["fromDate"] != null) {
      queryParameters["fromDate"] = requestParameters["fromDate"];
    }

    if (requestParameters["toDate"] != null) {
      queryParameters["toDate"] = requestParameters["toDate"];
    }

    if (requestParameters["pickup"] != null) {
      queryParameters["pickup"] = requestParameters["pickup"];
    }

    if (requestParameters["delivery"] != null) {
      queryParameters["delivery"] = requestParameters["delivery"];
    }

    if (requestParameters["service"] != null) {
      queryParameters["service"] = requestParameters["service"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    if (requestParameters["pageSize"] != null) {
      queryParameters["pageSize"] = requestParameters["pageSize"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/shipments`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentListResponseFromJSON(jsonValue),
    );
  }

  /**
   * Searchable, filterable and paginated over the carrier\'s whole history.  Filtering happens here rather than in the browser because the list is paginated: filtering a single page would quietly answer a different question from the one asked.
   * The carrier\'s booked shipments
   */
  async getCarrierShipments(
    requestParameters: GetCarrierShipmentsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentListResponse> {
    const response = await this.getCarrierShipmentsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Creates a draft pricing agreement between this carrier and the customer, notifies the FreightSimple rep who owns the account, and unlocks the full opportunity package immediately — the carrier does not wait for a human.  Idempotent: a carrier that already has an agreement for this customer gets that agreement back rather than a second one.
   * Register interest in pricing a customer
   */
  async markCarrierOpportunityInterestedRaw(
    requestParameters: MarkCarrierOpportunityInterestedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OpportunityInterestResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling markCarrierOpportunityInterested().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/carriers-api/v1/opportunities/{companyId}/interested`.replace(
          `{${"companyId"}}`,
          encodeURIComponent(String(requestParameters["companyId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OpportunityInterestResponseFromJSON(jsonValue),
    );
  }

  /**
   * Creates a draft pricing agreement between this carrier and the customer, notifies the FreightSimple rep who owns the account, and unlocks the full opportunity package immediately — the carrier does not wait for a human.  Idempotent: a carrier that already has an agreement for this customer gets that agreement back rather than a second one.
   * Register interest in pricing a customer
   */
  async markCarrierOpportunityInterested(
    requestParameters: MarkCarrierOpportunityInterestedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OpportunityInterestResponse> {
    const response = await this.markCarrierOpportunityInterestedRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Best-effort, fire-and-forget. The portal\'s credential is a permanent link shared around a carrier\'s team with a self-asserted name, so nothing else records what any of them actually came for.  Repeats of the same section by the same person inside a short window are collapsed, so the trail stays an answer to \"who looks at what\" rather than becoming a click stream.
   * Record that this browser opened a portal section
   */
  async recordCarrierPageViewRaw(
    requestParameters: RecordCarrierPageViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["pageViewRequest"] == null) {
      throw new runtime.RequiredError(
        "pageViewRequest",
        'Required parameter "pageViewRequest" was null or undefined when calling recordCarrierPageView().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/carriers-api/v1/activity/page-view`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PageViewRequestToJSON(requestParameters["pageViewRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Best-effort, fire-and-forget. The portal\'s credential is a permanent link shared around a carrier\'s team with a self-asserted name, so nothing else records what any of them actually came for.  Repeats of the same section by the same person inside a short window are collapsed, so the trail stays an answer to \"who looks at what\" rather than becoming a click stream.
   * Record that this browser opened a portal section
   */
  async recordCarrierPageView(
    requestParameters: RecordCarrierPageViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.recordCarrierPageViewRaw(requestParameters, initOverrides);
  }

  /**
   * The carrier\'s answer to one open operational task on one of their shipments.  A response closes the task only when it actually contains what the task was asking for — a `missed_pickup` needs a new pickup date, a `book_pickup` needs a confirmation number and a date. A response that carries only an internal note is recorded, flips the conversation turn back to FreightSimple, and leaves the task open. This is the difference between the carrier having said something and the carrier having answered the question.  `customerVisibleNote` becomes a tracking line on the shipment, visible to the customer immediately. `internalNote` is only ever seen by FreightSimple. They are deliberately separate fields.
   * Respond to an operational issue
   */
  async respondToCarrierOperationalIssueRaw(
    requestParameters: RespondToCarrierOperationalIssueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OperationalIssueResponseResult>> {
    if (requestParameters["operationalIssueResponseRequest"] == null) {
      throw new runtime.RequiredError(
        "operationalIssueResponseRequest",
        'Required parameter "operationalIssueResponseRequest" was null or undefined when calling respondToCarrierOperationalIssue().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/carriers-api/v1/operational-issues/respond`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OperationalIssueResponseRequestToJSON(
          requestParameters["operationalIssueResponseRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OperationalIssueResponseResultFromJSON(jsonValue),
    );
  }

  /**
   * The carrier\'s answer to one open operational task on one of their shipments.  A response closes the task only when it actually contains what the task was asking for — a `missed_pickup` needs a new pickup date, a `book_pickup` needs a confirmation number and a date. A response that carries only an internal note is recorded, flips the conversation turn back to FreightSimple, and leaves the task open. This is the difference between the carrier having said something and the carrier having answered the question.  `customerVisibleNote` becomes a tracking line on the shipment, visible to the customer immediately. `internalNote` is only ever seen by FreightSimple. They are deliberately separate fields.
   * Respond to an operational issue
   */
  async respondToCarrierOperationalIssue(
    requestParameters: RespondToCarrierOperationalIssueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OperationalIssueResponseResult> {
    const response = await this.respondToCarrierOperationalIssueRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
